

















































import Vue from "vue";
import moment from "moment-timezone";

let parser = require("cron-parser");

export default Vue.extend({
  name: "CronExpressionGenerator",
  components: {},
  props: ["checkinTime", "showReplace", "timeRange"],
  data() {
    return {
      visible: false,
      checkinModel: {
        timeframe: null,
        daily: null,
        weekly: [],
        monthly: null,
        dayIncrement: 1,
        dayIncrementStart: 1,
        daySpecific: [],
        weekdayOptions: [
          { value: "SUN", label: "SUN", disabled: false },
          { value: "MON", label: "MON", disabled: false },
          { value: "TUE", label: "TUE", disabled: false },
          { value: "WED", label: "WED", disabled: false },
          { value: "THU", label: "THU", disabled: false },
          { value: "FRI", label: "FRI", disabled: false },
          { value: "SAT", label: "SAT", disabled: false },
        ],
        monthlyOptions: [
          { value: "1", label: "Every first day of month", disabled: false },
          { value: "15", label: "Every 15th day of month", disabled: false },
          { value: "L", label: "Every last day of month", disabled: false },
        ],
        timeOptions: [
          { value: "00:00", label: "12:00 AM", disabled: false },
          { value: "00:30", label: "12:30 AM", disabled: false },
          { value: "01:00", label: "1:00 AM", disabled: false },
          { value: "01:30", label: "1:30 AM", disabled: false },
          { value: "02:00", label: "2:00 AM", disabled: false },
          { value: "02:30", label: "2:30 AM", disabled: false },
          { value: "03:00", label: "3:00 AM", disabled: false },
          { value: "03:30", label: "3:30 AM", disabled: false },
          { value: "04:00", label: "4:00 AM", disabled: false },
          { value: "04:30", label: "4:30 AM", disabled: false },
          { value: "05:00", label: "5:00 AM", disabled: false },
          { value: "05:30", label: "5:30 AM", disabled: false },
          { value: "06:00", label: "6:00 AM", disabled: false },
          { value: "06:30", label: "6:30 AM", disabled: false },
          { value: "07:00", label: "7:00 AM", disabled: false },
          { value: "07:30", label: "7:30 AM", disabled: false },
          { value: "08:00", label: "8:00 AM", disabled: false },
          { value: "08:30", label: "8:30 AM", disabled: false },
          { value: "09:00", label: "9:00 AM", disabled: false },
          { value: "09:30", label: "9:30 AM", disabled: false },
          { value: "10:00", label: "10:00 AM", disabled: false },
          { value: "10:30", label: "10:30 AM", disabled: false },
          { value: "11:00", label: "11:00 AM", disabled: false },
          { value: "11:30", label: "11:30 AM", disabled: false },
          { value: "12:00", label: "12:00 PM", disabled: false },
          { value: "12:30", label: "12:30 PM", disabled: false },
          { value: "13:00", label: "1:00 PM", disabled: false },
          { value: "13:30", label: "1:30 PM", disabled: false },
          { value: "14:00", label: "2:00 PM", disabled: false },
          { value: "14:30", label: "2:30 PM", disabled: false },
          { value: "15:00", label: "3:00 PM", disabled: false },
          { value: "15:30", label: "3:30 PM", disabled: false },
          { value: "16:00", label: "4:00 PM", disabled: false },
          { value: "16:30", label: "4:30 PM", disabled: false },
          { value: "17:00", label: "5:00 PM", disabled: false },
          { value: "17:30", label: "5:30 PM", disabled: false },
          { value: "18:00", label: "6:00 PM", disabled: false },
          { value: "18:30", label: "6:30 PM", disabled: false },
          { value: "19:00", label: "7:00 PM", disabled: false },
          { value: "19:30", label: "7:30 PM", disabled: false },
          { value: "20:00", label: "8:00 PM", disabled: false },
          { value: "20:30", label: "8:30 PM", disabled: false },
          { value: "21:00", label: "9:00 PM", disabled: false },
          { value: "21:30", label: "9:30 PM", disabled: false },
          { value: "22:00", label: "10:00 PM", disabled: false },
          { value: "22:30", label: "10:30 PM", disabled: false },
          { value: "23:00", label: "11:00 PM", disabled: false },
          { value: "23:30", label: "11:30 PM", disabled: false },
        ],
      },
    };
  },
  computed: {
    cronExpression() {
      let minute = 0;
      let hour = 0;
      if (this.checkinTime) {
        let checkinTime = moment(this.checkinTime, "HH:mm");
        hour = checkinTime.hour();
        minute = checkinTime.minute();
      }

      let weekday = "*";
      let monthday = "*";

      if (this.checkinModel.timeframe === "weekly") {
        weekday = this.checkinModel.weekly.length > 0 ? this.checkinModel.weekly.join(",") : "*";
        monthday = "?";
      } else if (this.checkinModel.timeframe === "daily" && this.checkinModel.daily === "weekday") {
        weekday = "1-5";
        monthday = "?";
      }

      if (this.checkinModel.timeframe === "monthly") {
        if (this.checkinModel.monthly === "dayIncrements") {
          monthday = `${this.checkinModel.dayIncrementStart}/${this.checkinModel.dayIncrement}`;
        } else if (this.checkinModel.monthly === "daySpecific") {
          monthday = this.checkinModel.daySpecific.length > 0 ? this.checkinModel.daySpecific.join(",") : "*";
        }
        weekday = "?";
      }

      let cron = `${minute} ${hour} ${monthday} * ${weekday}`;
      return cron;
    },

    rules() {
      let rules = {
        timeframe: [
          {
            required: true,
            message: "Please select Timeframe",
            trigger: "change",
          },
        ],
      };

      if (this.checkinModel.timeframe === "daily") {
        rules["daily"] = [
          {
            required: true,
            message: "Please select Pattern",
            trigger: "change",
          },
        ];
      }

      if (this.checkinModel.timeframe === "weekly") {
        rules["weekly"] = [
          {
            type: "array",
            required: true,
            message: "Please select Dates",
            validator: (rule, value, callback) => {
              if (value && value.length > 0) {
                callback();
              } else {
                callback(new Error("Please select Dates"));
              }
            },
            trigger: "change",
          },
        ];
      }

      if (this.checkinModel.timeframe === "monthly") {
        rules["monthly"] = [
          {
            required: true,
            message: "Please select Pattern",
            trigger: "change",
          },
        ];
      }

      return rules;
    },
  },
  mounted() {
    //this.setupCheckinUI(this.cronExpression);
    this.$Notice.config({
      top: 120,
      duration: 3,
    });
  },
  methods: {
    handlePopperShow() {
      this.checkinModel.timeframe = null;
      this.checkinModel.daily = null;
      this.checkinModel.weekly = [];
      this.checkinModel.monthly = null;
      this.checkinModel.dayIncrement = 1;
      this.checkinModel.dayIncrementStart = 1;
      this.checkinModel.daySpecific = [];

      this.setupCheckinUI(this.cronExpression);
    },
    setupCheckinUI(cron) {
      if (cron) {
        //`${minute} ${hour} ${monthday} * ${weekday}` : 0 1 ? * 1-5
        let sections = cron.split(" ");
        //this.checkinTime = `${sections[1].length === 1 ? "0" : ""}${sections[1]}:${sections[0].length === 1 ? "0" : ""}${sections[0]}`;
        if (sections[2] !== "*" && sections[2] !== "?") {
          this.checkinModel.timeframe = "monthly";

          let dayIncrementSections = sections[2].split("/").map((item) => Number(item));
          if (dayIncrementSections.length === 2) {
            this.checkinModel.monthly = "dayIncrements";
            this.checkinModel.dayIncrementStart = dayIncrementSections[0];
            this.checkinModel.dayIncrement = dayIncrementSections[1];
          } else {
            this.checkinModel.monthly = "daySpecific";
            this.checkinModel.daySpecific = sections[2].split(",");
          }
        } else if (sections[4] !== "*" && sections[4] !== "?" && sections[4] !== "1-5") {
          this.checkinModel.timeframe = "weekly";
          this.checkinModel.weekly = sections[4].split(",");
        } else {
          this.checkinModel.timeframe = "daily";
          this.checkinModel.daily = sections[4] === "1-5" ? "weekday" : "everyDay";
        }
      } else {
        this.checkinModel.timeframe = null;
        this.checkinModel.daily = null;
        this.checkinModel.weekly = [];
        this.checkinModel.monthly = null;
      }
    },
    generate(isAppend) {
      (this.$refs.CronForm as any).validate((valid: boolean) => {
        if (valid) {
          this.visible = false;

          let start = moment(this.timeRange.startDate);
          let end = moment(this.timeRange.endDate);
          if (this.timeRange.timezoneName) {
            start = start.tz(this.timeRange.timezoneName);
            end = end.tz(this.timeRange.timezoneName);
          }

          var options = {
            currentDate: start,
            endDate: end,
            iterator: true,
          };

          try {
            var items = [];

            if (
              this.checkinTime &&
              ((this.checkinModel.timeframe === "daily" && this.checkinModel.daily) ||
                (this.checkinModel.timeframe === "weekly" && this.checkinModel.weekly.length > 0) ||
                (this.checkinModel.timeframe === "monthly" &&
                  ((this.checkinModel.monthly === "dayIncrements" && this.checkinModel.dayIncrementStart && this.checkinModel.dayIncrement) ||
                    (this.checkinModel.monthly === "daySpecific" && this.checkinModel.daySpecific.length > 0))))
            ) {
              var interval = parser.parseExpression(this.cronExpression, options);
              while (true) {
                try {
                  var obj = interval.next();
                  items.push(obj.value._date);
                } catch (e) {
                  break;
                }
              }
            }
            this.$emit("on-generate", { cron: this.cronExpression, days: items, isAppend: isAppend });
          } catch (err) {
            console.log("Error: " + err.message);
          }
        } else {
        }
      });
    },
  },
});
